export default __webpack_public_path__ + "static/media/ContestInterest.fd098d69.svg";